import { createFileRoute } from "@tanstack/react-router";
import Faq from "@/pages/Faq";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/intrebari-frecvente/")({
  head: () => routeHead("/intrebari-frecvente/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Faq />
  );
}
